import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SiteListComponent } from './site-list/site-list.component';
import { AddEditSiteListComponent } from './add-edit-site-list/add-edit-site-list.component';
import { AuthGuard } from '../services/auth-guard';
import { AddEditCameraListComponent } from './add-edit-camera-list/add-edit-camera-list.component';
import { CameraListComponent } from './camera-list/camera-list.component';
import { CancelSiteListComponent } from './cancel-site-list/cancel-site-list.component';
import { FootageQueueListComponent } from './footage-queue-list/footage-queue-list.component';
import { GetAllEc2Component } from './get-all-ec2/get-all-ec2.component';
import { MaskCamsComponent } from './masking/mask-cams/mask-cams.component';
import { MaskingComponent } from './masking/masking.component';

const routes: Routes = [
  { path: 'site-list', component: SiteListComponent },
  { path: 'add-sitelist', component: AddEditSiteListComponent},
  { path: 'sitelist/:id', component: AddEditSiteListComponent},
  { path: 'camera-list', component: CameraListComponent},
  { path: 'sitelist/:id/addcamera', component: AddEditCameraListComponent},
  { path: 'edit-camera-list/:id', component: AddEditCameraListComponent,canActivate:[AuthGuard]},
  { path: 'masking', component: MaskingComponent },
  { path: 'masking/mask-cams/:id', component: MaskCamsComponent },
  { path: 'ec2', component: GetAllEc2Component },
  { path: 'cancelled-site-list', component: CancelSiteListComponent },
  { path: 'footage-list', component:FootageQueueListComponent },
  // Add more routes here
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ]
})
export class CameraServerRoutingModule { }
